import "./Settings.scss";

import autoBind from "auto-bind";
import React from "react";

import withUserData from "../../../../../../hocs/withUserData";
import accessLevelsMap from "../../../../../../lib/access/accessLevelsMap";
import getAccessLevel from "../../../../../../lib/access/getAccessLevel";
import UniversalTableContext from "../../../../../../lib/UniversalTable/UniversalTableContext";
import { hasInvalidRangeFilterSettings } from "../../../../../../lib/UniversalTable/CoreHelpers/rangeFilterHelpers";
import { preserveLockedRecord } from "../../../../../../lib/UniversalTable/lockedSettings";
import NewModal from "../../../../modal/NewModal";
import OrderedFilters from "./components/OrderedFilters";
import Sorting from "./components/Sorting";

@withUserData
class Settings extends React.Component {
  static contextType = UniversalTableContext;

  state = {
    settingsState: null
  };

  constructor(props) {
    super(props);

    autoBind.react(this);
  }

  componentDidMount() {
    const { pagination, sortBy, search, filters } = this.context;

    this.setSettingsState({ pagination, sortBy, search, filters });
  }

  applySettings() {
    const { hideSettings } = this.props;
    let { settingsState } = this.state;
    const filterColumns = this.context.getFilterColumns();

    if (
      hasInvalidRangeFilterSettings(settingsState?.filters, filterColumns)
    ) {
      return;
    }

    settingsState = {
      ...settingsState,
      search: preserveLockedRecord(
        settingsState.search,
        this.context.search,
        this.context.lockedSettings
      ),
      filters: preserveLockedRecord(
        settingsState.filters,
        this.context.filters,
        this.context.lockedSettings
      ),
      pagination: {
        ...this.context.pagination,
        current: 1
      }
    };

    this.context.setTableState(settingsState, () => {
      this.context.reFetchAfterSettingsChange();
    });

    hideSettings();
  }

  getSettingsState() {
    return this.state.settingsState;
  }

  setSettingsState(newState) {
    this.setState(({ settingsState }) => ({
      settingsState: {
        ...settingsState,
        ...newState
      }
    }));
  }

  render() {
    const { translate, hideSettings, userData, hasPermission } = this.props;
    const settingsState = this.getSettingsState();

    const tableColumns = this.context.getColumns();
    const filterColumns = this.context.getFilterColumns();

    const accessLevel = getAccessLevel(userData, {});
    const userHasAccess = accessLevel === accessLevelsMap.HAS_PREMIUM_ACCESS;

    return (
      <NewModal
        hideModal={hideSettings}
        title={translate("Filters")}
        acceptButtonText={translate("Apply")}
        cancelButtonText={translate("Cancel")}
        hideOnAccept={false}
        onAccept={this.applySettings}
      >
        <div className="universal-table-settings">
          {settingsState ? (
            <div className="settings-elements-wrapper">
              <div className="settings-element sorting">
                <h3>{translate("Sorting")}</h3>
                <Sorting
                  columns={tableColumns}
                  userHasAccess={userHasAccess}
                  settingsState={settingsState}
                  setSettingsState={this.setSettingsState}
                />
              </div>
              <div className="settings-element">
                <OrderedFilters
                  columns={filterColumns}
                  userHasAccess={userHasAccess}
                  hasPermission={hasPermission}
                  settingsState={settingsState}
                  setSettingsState={this.setSettingsState}
                  lockedSettings={this.context.lockedSettings}
                />
              </div>
            </div>
          ) : null}
        </div>
      </NewModal>
    );
  }
}

export default Settings;
